import { ReceiptsEventType } from './../receipts.event.type';
import { Component, OnInit, ViewEncapsulation, ViewChild, Input, OnDestroy } from '@angular/core';
import { TweenMax, Quint } from 'gsap';
import { EventTypes } from '../../../shared/EventTypes';
import { ReceiptsService } from '../receipts.service';
import { Receipt, ReceiptType } from '../models/receipt';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { Util } from '../../../utils/util';
import { Detail } from '../models/details';
import { AutenticationEventType } from '../../../autentication/autentication.event.type';
import * as printJS from 'print-js';
import { Router } from '@angular/router';

@Component({
	selector: 'app-receipts-table',
	templateUrl: './receipts-table.component.html',
	styleUrls: ['./receipts-table.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class ReceiptsTableComponent implements OnInit, OnDestroy {

	private dateBegin: any = new Date();
	private dateEnd: Date = null;

	isLoading: boolean;
	isLoadingDetails: boolean;
	detailsShow: boolean;
	receipt: Array<Receipt>;
	receiptDetail: Detail = new Detail();

	constructor(private receiptsService: ReceiptsService, private router: Router) {  }

	ngOnInit() {

		AppEventDispatcher.listen(AutenticationEventType.ACCOUNT.CHANGE_ACCOUNT, () => {
			this.load();
		});


		AppEventDispatcher.listen(ReceiptsEventType.UPDATE, data => {
			this.dateBegin = data.dateBegin;
			this.dateEnd = data.dateEnd;
			this.load();

		});

		this.load();

	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(ReceiptsEventType.UPDATE);
		AppEventDispatcher.removeListener(AutenticationEventType.ACCOUNT.CHANGE_ACCOUNT);
	}

	getCpfCnpj(cpfCnpj: string) {
		return Util.maskCpfCnpjPix(cpfCnpj);
	}

	loadDetails(e, idReceipt, typeReceipt, idtransaction, newReceipt) {
		if ($(e.target).hasClass('print')) {
			return;
		}


		const itemSelected = e.currentTarget.nextElementSibling;
		const listSelected = e.currentTarget;

		const arrowSelected = $(e.currentTarget).find('.arrow-right');

		if (!this.isLoadingDetails) {


			this.isLoadingDetails = true;

			if (!this.detailsShow) {
				$('.detail').appendTo(itemSelected);
				$('.detail-preloader').appendTo($(e.currentTarget));

				TweenMax.to(arrowSelected, .5, {
					rotation: 90,
					ease: Quint.easeOut
				});

				this.receiptsService.getReceiptsDetail(idReceipt, typeReceipt, idtransaction, newReceipt).subscribe( data => {

					this.receiptDetail = data;

					const inte = setInterval(() => {
						if ($('.detail-title').length > 0) {
							clearInterval(inte);

							const detailHeight = $('.detail').outerHeight();

							$(listSelected).addClass('open');

							TweenMax.to(itemSelected, .8, {
								height: detailHeight,
								ease: Quint.easeOut,
								onComplete: () => {
									this.detailsShow = true;
									this.isLoadingDetails = false;
									$(itemSelected).addClass('active');
									$(itemSelected).addClass('printable');
									$(e.target).closest('.list').find('.print-button').show();

									TweenMax.to('.detail', .8, {
										top: 0,
										ease: Quint.easeOut
									});
								}
							});
						}
					}, 10);
				}, error => {
					this.isLoadingDetails = false;
					const message = error.error && error.error.Mensagem ? error.error.Mensagem : 'Ocorreu um erro, tente novamente mais tarde.';
					AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: message });
				});
			} else {

				if ($(itemSelected).hasClass('active')) {
					this.isLoadingDetails = false;

					$(e.target).closest('.list').find('.print-button').hide();

					$(listSelected).removeClass('open');

					TweenMax.to('.append-detail', .8, {
						height: 0,
						ease: Quint.easeOut,
						onComplete: () => {
							this.detailsShow = false;
							$('.append-detail').removeClass('active');
							$('.append-detail').removeClass('printable');

							TweenMax.to('.detail', .8, {
								top: '100%',
								ease: Quint.easeOut
							});
						}
					});

					TweenMax.to(arrowSelected, .5, {
						rotation: 0,
						ease: Quint.easeOut
					});
				} else {

					$('.list').find('.print-button').hide();

					TweenMax.to('.arrow-right', .5, {
						rotation: 0,
						ease: Quint.easeOut
					});

					$('.list-detail').removeClass('open');

					TweenMax.to('.append-detail', .8, {
						height: 0,
						ease: Quint.easeOut,
						onComplete: () => {
							this.detailsShow = false;
							$(itemSelected).removeClass('active');

							TweenMax.to('.detail', .8, {
								top: '100%',
								ease: Quint.easeOut
							});
						}
					});

					$('.detail').appendTo(itemSelected);
					$('.detail-preloader').appendTo(e.currentTarget);

					TweenMax.to(arrowSelected, .5, {
						rotation: 90,
						ease: Quint.easeOut
					});

					this.receiptsService.getReceiptsDetail(idReceipt, typeReceipt, idtransaction, newReceipt).subscribe( data => {

						this.receiptDetail = data;

						const inte = setInterval(() => {
							if ($('.detail-title').length > 0) {
								clearInterval(inte);

								const detailHeight = $('.detail').outerHeight();

								$(listSelected).addClass('open');

								TweenMax.to(itemSelected, .8, {
									height: detailHeight,
									ease: Quint.easeOut,
									onComplete: () => {
										this.detailsShow = true;
										this.isLoadingDetails = false;
										$(itemSelected).addClass('active');
										$(e.target).closest('.list').find('.print-button').show();

										TweenMax.to('.detail', .8, {
											top: 0,
											ease: Quint.easeOut
										});
									}
								});
							}
						}, 10);
					}, error => {
						this.isLoadingDetails = false;
						AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
					});
				}


			}
		}
	}

	load() {

		this.preload(true);
		this.isLoading = true;

		let time = 1;
		const timeLoader = setInterval(() => {
			time++;
		}, 1000);

		this.receiptsService.getReceiptsList(this.dateBegin, this.dateEnd).subscribe( data => {

			this.receipt = data;
			$('.detail').appendTo($('body'));
			$('.detail').removeAttr('style');
			$('.detail-preloader').appendTo($('body'));
			this.detailsShow = false;

			if (time > 3) {
				this.preload(false);
				this.isLoading = false;
			}	else {
				TweenMax.delayedCall(3 - time, () => {
					this.preload(false, 3 - time);
					this.isLoading = false;
				});
			}
			clearInterval(timeLoader);

		}, error => {
			this.isLoading = false;
			this.preload(false);
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
		});


	}

	print(e, receiptId, receiptType: ReceiptType, transactionId, newReceipt: boolean) {
		if (receiptType === ReceiptType.PIX || receiptType === ReceiptType.PIX_DEVOLVIDO) {
			this.router.navigate(['pix/comprovante/' + transactionId + '/lista']);
		}
		if ((receiptType === 'Boleto' || receiptType === 'Convenio') && newReceipt) {
			this.router.navigate(['comprovantes/boleto']);
		}
		else if(receiptType === ReceiptType.RECARGA){
			this.router.navigate(['comprovantes/recarga']);
		}
		else if([ReceiptType.TED, ReceiptType.DOC, ReceiptType.ENTRECONTAS].includes(receiptType)){
			this.router.navigate(['comprovantes/transferencia']);
		}
		else {
			$(e.target).closest('.print-button').find('.print').hide();
			$(e.target).closest('.print-button').find('.print-loader').show();
			this.receiptsService.getReceiptPdf(receiptId, receiptType, 'PDF').subscribe(
				data => {
					printJS({ printable: data, type: 'pdf', base64: true });
					$(e.target).closest('.print-button').find('.print').show();
					$(e.target).closest('.print-button').find('.print-loader').hide();
			});
		}
	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD, {element: '[data-component="receipts"] .content', show: active, delay: delay});
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/receipts/receipts-table/receipts-table.component.ts